import { gql } from 'apollo-angular';

export var update_apps = gql`
  mutation updateApps($input: UpdateFundingRound!, $projectid: ID) {
    updateApps(input: $input){
      id, year, number, name, due_date, award_date,
      organization{
        id, name
      },
      state{
        name
      },
      applications(project_id: $projectid){
        id, amount_requested, request_date, awarded
        taxCreditType{
            id, level, name
        },
        taxCreditDesignation{
            id, name
        },
        organization{
            id, name
        },
        person{
            id, name
        },
        project{
          id,
          projectStatuses{
            id, is_primary, active,
            status{
              id, name
            },
            statusSequence{
              id, name,
              status_sequence_details{
                index,
                status{
                  id, name
                },
                milestoneStatus{
                  id, pipeline_milestone_id, status_sequence_detail_id
                }
              }
            }
          },
          pipelineProjects{
            id, active,
            pipelineProjectDates{
              id, date, initial_target, target,
              pipelineMilestone{
                milestone{
                  name
                },
                milestoneStatus{
                  id, pipeline_milestone_id, status_sequence_detail_id
                }
              }
            },
            pipeline{
              name
            }
          },
        }
      }
    }
  }
`;

export var update_project_apps = gql`
  mutation updateProjectApps($input: UpdateProjectApplications!, $orgid: ID) {
    updateProjectApps(input: $input){
      id,
      applications(funding_round_id: null, organization_id: $orgid){
        id, amount_requested, request_date, awarded
        taxCreditType{
          id, level, name
        },
        taxCreditDesignation{
          id, name
        },
        organization{
          id, name
        },
        person{
          id, name
        }
      },
      projectStatuses{
        id, is_primary, active,
        status{
          id, name
        },
        statusSequence{
          id, name,
          status_sequence_details{
            index,
            status{
              id, name
            },
            milestoneStatus{
              id, pipeline_milestone_id, status_sequence_detail_id
            }
          }
        }
      },
      pipelineProjects{
        id, active,
        pipelineProjectDates{
          id, date, initial_target, target,
          pipelineMilestone{
            milestone{
              name
            },
            milestoneStatus{
              id, pipeline_milestone_id, status_sequence_detail_id
            }
          }
        },
        pipeline{
          name
        }
      },
    }
  }
`;

export var delete_app = gql`
  mutation deleteApp($id: ID!) {
    deleteApp(id: $id){
      id
    }
  }
`;
